import { watch, onUnmounted } from 'vue'

/**
 * Sluit een modal/dialoog met de Escape-toets.
 * SSR-veilig (geen window-toegang op de server) en ruimt de listener netjes op.
 *
 * @param {import('vue').Ref<boolean>} isOpen  Reactieve open-status.
 * @param {Function} close                     Functie die de modal sluit.
 */
export function useEscToClose(isOpen, close) {
  if (typeof window === 'undefined') return

  const onKey = (e) => { if (e.key === 'Escape') close() }

  watch(isOpen, (open) => {
    if (open) window.addEventListener('keydown', onKey)
    else window.removeEventListener('keydown', onKey)
  }, { immediate: true })

  onUnmounted(() => window.removeEventListener('keydown', onKey))
}
